/**
 * Timer Komponente
 * Zeigt verbleibende Zeit im mm:ss Format an
 */

import { memo } from 'react';

interface TimerProps {
  seconds: number;
  warningThreshold?: number; // Sekunden unter denen Warnung angezeigt wird
  className?: string;
}

export const Timer = memo(function Timer({
  seconds,
  warningThreshold = 120,
  className = '',
}: TimerProps) {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const isLow = seconds < warningThreshold;

  return (
    <div
      className={`text-sm font-mono ${
        isLow ? 'text-red-600 animate-pulse' : 'text-charcoal-500'
      } ${className}`}
      role="timer"
      aria-live="polite"
      aria-label={`${minutes} Minuten und ${secs} Sekunden verbleibend`}
    >
      {minutes}:{secs.toString().padStart(2, '0')}
    </div>
  );
});

export default Timer;
